import {
  GetUserGroup, NewUserGroup, EditUserGroup, DeleteUserGroup,
  UserGroupListAuth, UpdateGroupAuth
} from '@/apis/userGroup'
import { fixPageAfterDel } from '@/utils/utils'

import { EditUserGroupModal, AuthsModal } from './components'

import columns from './tableConfig'
import { searchItems } from './searchFormConfig'
let searchCache = {}

export default {
  name: 'User.UserGroup',
  components: { EditUserGroupModal, AuthsModal },
  props: {
    defaultGroup: { // 通过路由组件传参，可以匹配编程式导航时传入的 params 的内容
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      searchItems,
      searching: false,

      columns,
      data: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      targetGroup: null,

      // 新增、修改用户组
      showEditModal: false,

      // 用户组权限设置
      showAuthsModal: false,
      checkedAuth: {}
    }
  },
  created () {
    // console.log('--PlatformUserGroup created--', this.defaultGroup)
    this.$nextTick(() => {
      this.$refs.searchForm.handlerSearch()
    })
  },
  methods: {
    // ------------------------------- 用户组列表 -------------------------------
    // 查询用户组
    async getUserGroup(page = 1, searchData) {
      try {
        this.loading = true
        // 确定搜索条件
        searchData = searchData || searchCache
        // 缓存搜索条件
        searchCache = searchData

        const { collection: data, pageInfo } = await GetUserGroup({
          ...searchData,
          perPage: this.pagination.pageSize
        })
        this.data = data.map(g => Object.assign(g, { key: g.id }))

        this.pagination.current = page
        this.pagination.total = pageInfo.total
      } catch (error) { }
      this.loading = this.searching = false
    },
    // 翻页
    handlePageTurn(pagination, filters, sorter) {
      const { current } = pagination
      this.getUserGroup(current)
    },

    // ------------------------------- 用户组编辑 -------------------------------
    // 打开编辑用户组模态框
    handlerOpenEditModal(data) {
      this.targetGroup = data || null
      this.showEditModal = true
    },
    // 关闭编辑用户组模态框
    handlerCloseEditModal() {
      this.targetGroup = null
      this.showEditModal = false
    },
    // 提交新增\修改用户组信息
    async handleSubmitEdit(data) {
      try {
        if (!this.targetGroup) {
          await NewUserGroup(data)
          this.getUserGroup()
        } else {
          await EditUserGroup(data)
          this.getUserGroup(this.pagination.current)
        }
      } catch (error) { }

      this.handlerCloseEditModal()
    },

    // 删除用户组
    handlerDeleteGroup(data) {
      const { name, id } = data
      this.$confirm({
        title: `即将删除用户组：${name}`,
        content: '删除后，组内成员将取消该组的所有权限！',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        confirmLoading: true,
        onOk: () => {
          return DeleteUserGroup({ id }).then(() => {
            this.pagination = fixPageAfterDel(this.pagination)
            this.getUserGroup(this.pagination.current)
          })
        }
      })
    },

    // ------------------------------- 用户组权限设置 -------------------------------
    // 提交用户组权限设置信息
    async handleSubmitAuths(userAuthIds) {
      try {
        await UpdateGroupAuth({
          userAuthIds,
          userGroupId: this.targetGroup.id
        })
      } catch (error) {}

      this.handlerCloseAuthsModal()
    },
    // 打开授权模态框
    async handlerOpenAuthsModal(data) {
      try {
        this.targetGroup = data
        const { collection } = await UserGroupListAuth(this.targetGroup)
        this.showAuthsModal = true
        this.checkedAuth = collection
      } catch (error) {}
    },
    // 关闭用户组权限设置模态框
    handlerCloseAuthsModal() {
      this.targetGroup = null
      this.checkedAuth = []
      this.showAuthsModal = false
    },

    // ------------------------------- 查看成员 -------------------------------
    handlerShowUsers(data) {
      this.$router.push({
        name: 'Platform.User',
        params: { defaultGroup: data }
      })
    }
  }
}
